import { IDiscountRepository } from '../domain/IDiscountRepository'

export class ImportAssociations {
  constructor(private readonly discountRepository: IDiscountRepository) {}

  async execute(sellerId: number, file: File) {
    return this.discountRepository.importAssociations(sellerId, file)
  }
}
